import { useNavigate } from "react-router";
import { Button, Typography } from "antd";

import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";

const { Paragraph } = Typography;

export default function SendSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Typography.Title level={5} className={styles.title}>
        Please check your email
      </Typography.Title>
      <Paragraph style={{ marginBottom: 4 }}>
        If an account is associated with this address, we&apos;ve sent
        instructions to reset your password.
      </Paragraph>
      <Paragraph className={styles.secondary}>
        Please check your inbox and spam folder.
      </Paragraph>
      <Button
        size="large"
        type="link"
        block
        onClick={() => navigate("/sign-in")}
        style={{ marginBottom: 24 }}
      >
        {t("common.backToLogin")}
      </Button>
    </>
  );
}
